import { css } from 'styled-components';
import { getBaseTheme } from '@Themes';

const { spaces, texts } = getBaseTheme();

export default css`
    div[class*='BoxText'] {
        font-size: ${texts.sizes.s.fontSize};
    }

    div[class*='SelectTrigger'] {
        :focus {
            outline: none;
        }
    }

    div[class*='SelectOverlay'] {
        overflow: scroll;
    }

    div[class*='SelectMenu'] {
        max-height: 26rem;

        > ul > li {
            padding: 0;
            > * {
                padding: ${spaces.insetSquish.m};
            }
        }
    }
`;
